import { Link } from 'react-router-dom';
import './HelpLink.css';

/**
 * Small inline "need help with this?" callout linking into the Help
 * Centre (or a specific KB article/category), for use at the point a
 * user might actually want it - see HelpCentre.css's design language.
 */
export default function HelpLink({ to, children, className = '', showArrow = true }) {
  return (
    <Link to={to} className={`help-link ${showArrow ? '' : 'help-link--inline'} ${className}`.trim()}>
      {children}
      {showArrow && (
        <>
          {' '}
          <span aria-hidden="true">→</span>
        </>
      )}
    </Link>
  );
}
